<script setup lang="ts">
import type { Contract } from '~/layers/forms/models/index'

interface Props {
  modelValue: Contract
}

const props = defineProps<Props>()

const emits = defineEmits(['update:modelValue', 'end-process'])
const model = useVModel(props, 'modelValue', emits)

const endProcess = async () => {
  emits('end-process')
}
</script>

<template>
  <div class="grid gap-2 lg:grid-cols-3 lg:gap-4">
    <FormsResumeCard
      :bg="$viewport.isLessThan('lg') ? 'light' : 'dark'"
      text="Información del contratante"
      icon-class="icon-[ph--user-bold]"
      layout="horizontal"
      closed-by-default
    >
      <FormsResumeSumaryRequesterInfo :data="model" />
    </FormsResumeCard>

    <FormsResumeCard
      :bg="$viewport.isLessThan('lg') ? 'light' : 'dark'"
      text="Información del producto"
      icon-class="icon-[ph--shield-check-bold]"
      layout="horizontal"
    >
      <FormsResumeSumaryProductInfo
        :coverage="model.coverage"
        :payment-info="model.paymentInfo"
      />
    </FormsResumeCard>

    <FormsResumeCard
      text="Forma de pago"
      icon-class="icon-[ph--credit-card-bold]"
      layout="horizontal"
    >
      <FormsResumeSumaryPaymentInfo
        v-model="model.paymentInfo"
        :coverage="model.coverage"
        @pay="endProcess"
      />
    </FormsResumeCard>
  </div>
</template>
